"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("../App.css");
var _reactRedux = require("react-redux");
var _uuid = _interopRequireDefault(require("uuid"));
var _actions = require("../actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const mapStateToProps = state => ({
  state: state.apitester
});
const mapDispatchToProps = dispatch => ({
  copyIdToken: () => dispatch((0, _actions.copyIdToken)()),
  handleSubmitShortcut: shortcut => dispatch((0, _actions.handleSubmitShortcut)(shortcut)),
  request: (requestParams, headers) => dispatch((0, _actions.request)(requestParams, headers))
});
class Shortcuts extends _react.Component {
  constructor(props) {
    super(props);
  }
  componentDidUpdate() {
    if (this.props.state.isFetching === true) {
      let requestParams = {
        baseURL: this.props.state.baseUrl,
        url: this.props.state.endpoint,
        method: this.props.state.httpMethod,
        data: this.props.state.body
      };
      let headers = this.props.state.headers;
      this.props.request(requestParams, headers);
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "row justify-content-end"
    }, this.props.state.shortcuts.map(shortcut => /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-auto colMargin",
      key: _uuid.default.v4()
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      onClick: e => handleShortcut(shortcut, this.props, e),
      className: "btn btn-secondary"
    }, shortcut.name))));
  }
}
function handleShortcut(shortcut, props) {
  Promise.resolve(copyToken(shortcut, props)).then(props => {
    setDefaultValues(shortcut, props);
  }) /* 
     .then(res => {
        let state = props.handleSubmitShortcut(shortcut);
     }) */.then(() => {
    doRequest(props);
  });
}
function doRequest(props) {
  if (props.state.isFetching === true) {
    let requestParams = {
      baseURL: this.props.state.baseUrl,
      url: this.props.state.endpoint,
      method: this.props.state.httpMethod,
      data: this.props.state.body
    };
    let headers = props.state.headers;
    props.request(requestParams, headers);
  }
}
function copyToken(shortcut, props) {
  if (shortcut.useAuth) {
    //const res=null;
    props.copyIdToken();
    return Promise.resolve();
  }
}
function setDefaultValues(shortcut /* , props */) {
  if (shortcut.useAuth === undefined) shortcut.useAuth = true;
  if (shortcut.httpMethod === undefined) shortcut.httpMethod = 'GET';
  if (shortcut.headers === undefined) shortcut.headers = '';
  if (shortcut.body === undefined) shortcut.body = '';
  return Promise.resolve();
}

/* 
function disableButtons () {

    //console.log("buttons disabled");

    let buttons = document.getElementsByClassName("btn-primary");

    for (let i=0; i<buttons.length; i++)
        buttons[i].disabled=true;

	document.getElementById("submitButton").disabled=true;
	
    document.getElementById("submitButton").innerHTML="<span className='spinner-grow spinner-grow-sm' role='status' aria-hidden='true'> </span>  Sending...";

}
 */
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Shortcuts);
module.exports = exports.default;